<div style="max-width: fit-content; margin-left: auto; margin-right: auto;">
    <div *ngIf="!complaintSuccess">
        <div>
            <mat-card appearance="outlined">
                <mat-card-title style="margin: 15px;">Please select your location</mat-card-title>
                <mat-card-content>
                    <div *ngIf="showAreasDropDown">
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Area Name</mat-label>
                            <mat-select [(ngModel)]="areaId" placeholder="Area Name" (selectionChange)="onAreaChange()">
                                <mat-option *ngFor="let area of areas" [value]="area.code">
                                    {{ area.value }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div>
                            <div>
                                <mat-form-field appearance="outline">
                                    <mat-label>Search here...</mat-label>
                                    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Area, Location, Resident etc...">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div>
                        <table mat-table [dataSource]="dataSource" matSort>
                            <ng-container matColumnDef="areaName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Area Name </th>
                                <td mat-cell *matCellDef="let element"> {{element.areaName}} </td>
                            </ng-container>
    
                            <ng-container matColumnDef="locationName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Location Name </th>
                                <td mat-cell *matCellDef="let element"> {{element.locationName ? element.locationName :
                                    'N/A'}} </td>
                            </ng-container>
    
                            <ng-container matColumnDef="locationCode">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
                                <td mat-cell *matCellDef="let element"> {{element.locationCode}} </td>
                            </ng-container>

                            <ng-container matColumnDef="residentName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Resident Name</th>
                                <td mat-cell *matCellDef="let element"> {{ element.residentName }} </td>
                            </ng-container>
    
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef> Choose One </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-checkbox (click)="$event.stopPropagation()" (change)="onCheckboxChange(element)"
                                        [checked]="selection.isSelected(element)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
    
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
    
                        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    
        <div *ngIf="locationSelected" style="margin-top: 20px; width: 800px;">
            <mat-card appearance="outlined">
                <mat-card-title style="margin: 15px;">Add Complaints</mat-card-title>
                <mat-card-content style="max-width: fit-content; margin-left: auto; margin-right: auto;">
                    <form [formGroup]="complaintForm">
                        <mat-accordion>
                            <mat-expansion-panel *ngFor="let complaint of complaints.controls; let i = index" [expanded]="true" style="width: 700px;">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        Complaint {{ i + 1 }} 
                                        {{ getComplaintCategoryControl(i).value !== null ? ' - ' + getComplaintCategoryControl(i).value : '' }} 
                                        {{ getMasterComplaintControl(i).value !== null ? ' - ' + getMasterComplaintControl(i).value : '' }}
                                    </mat-panel-title>
                                    <!-- Delete button on the right side -->
                                    <button mat-icon-button (click)="removeComplaint(i)" style="margin-left: auto;">
                                        <mat-icon style="color: red;">delete</mat-icon>
                                    </button>
                                </mat-expansion-panel-header>
                            
                                <div [formGroup]="getComplaintGroup(i)">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Complaint Category</mat-label>
                                        <mat-select required [formControl]="getComplaintCategoryControl(i)" (selectionChange)="onCategorySelected($event.value, i)">
                                            <mat-option *ngFor="let category of categoryNameOptions" [value]="category.categoryName">
                                                {{ category.categoryName }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                            
                                    <mat-form-field appearance="outline">
                                        <mat-label>Master Complaint Description</mat-label>
                                        <mat-select required [formControl]="getMasterComplaintControl(i)" (selectionChange)="onMasterCategorySelected($event.value, i)">
                                            <mat-option *ngFor="let description of masterComplaintDescriptionOptionsMap[i] || []" [value]="description.complaintDescription">
                                                {{ description.complaintDescription }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                            
                                    <mat-form-field appearance="outline">
                                        <mat-label>Comment</mat-label>
                                        <textarea maxlength="100" placeholder="Maximum of 100 characters" matInput [formControl]="getCommentControl(i)"></textarea>
                                    </mat-form-field>
                                </div>
                            </mat-expansion-panel>
                            
                        </mat-accordion>
                        <div style="margin-top: 20px; text-align: center;">
                            <button mat-flat-button (click)="addComplaint()">{{ complaints.controls.length > 0 ? 'Add Another Complaint' : 'Add Your Complaint'}}</button>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
    
            <mat-card appearance="outlined" style="margin-top: 20px; width: 800px;" *ngIf="complaints.controls.length > 0">
                <mat-card-title style="margin: 15px;">Additional Information</mat-card-title>
                <mat-card-content>
                    <div>
                        <mat-form-field appearance="outline" style="width: 45%; margin-right: 5%;">
                            <mat-label>Preferred day</mat-label>
                            <mat-select required [(value)]="preferredDayValue">
                                <mat-option *ngFor="let preferredDay of preferredDayType || []"
                                    [value]="preferredDay.lookupCode">
                                    {{ preferredDay.lookupValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="width: 45%; margin-left: 5%;">
                            <mat-label>Preferred time</mat-label>
                            <mat-select required [(value)]="preferredTimeValue">
                                <mat-option *ngFor="let preferredTime of preferredTimeType || []"
                                    [value]="preferredTime.lookupCode">
                                    {{ preferredTime.lookupValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
    
                    <mat-form-field appearance="outline">
                        <mat-label>Additional Instructions</mat-label>
                        <textarea [(ngModel)]="additionalInstructions" matInput maxlength="150" placeholder="Maximum of 150 characters"></textarea>
                    </mat-form-field>
                </mat-card-content>
                <div style="text-align: center; margin: 20px;">
                    <button mat-stroked-button style="margin-right: 10px;" (click)="backToHome()">Back</button>
                    <button mat-flat-button [disabled]="!complaintForm.valid" (click)="submitComplaint()">Submit</button>
                </div>
            </mat-card>
            <div style="height: 50px;"></div>
        </div>
    </div>
    <div *ngIf="complaintSuccess">
        <mat-card class="complaint-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Complaint Details</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p class="success-message">Complaint Booked Successfully</p>
      
            <ng-container *ngFor="let complaintConfirmation of complaintConfirmations; let i = index;">
              <mat-expansion-panel style="margin-bottom: 20px;">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Complaint Reference: {{ complaintConfirmation.complaintRefNumber }}
                  </mat-panel-title>
                  <mat-panel-description>
                    Department: {{ complaintConfirmation.departmentName }} | Category: {{ complaintConfirmation.complaintCategory }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
      
                <div class="complaint-info">
                  <p><strong>Employee Name:</strong> {{ complaintConfirmation.employeeName }}</p>
                  <p><strong>Department Name:</strong> {{ complaintConfirmation.departmentName }}</p>
                  <p><strong>Category Name:</strong> {{ complaintConfirmation.complaintCategory }}</p>
      
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        Complaint Lines ({{ complaintConfirmation.complaintLines.length }} Items)
                      </mat-panel-title>
                    </mat-expansion-panel-header>
      
                    <ng-container *ngFor="let complaintLines of complaintConfirmation.complaintLines">
                      <div class="complaint-line-item">
                        <p><strong>Line Number:</strong> {{ complaintLines.lineNumber }}</p>
                        <p><strong>Description:</strong> {{ complaintLines.complaintDescription }}</p>
                        <p><strong>Due Date:</strong> {{ complaintLines.dueDate | date: 'longDate' }}</p>
                      </div>
                    </ng-container>
                  </mat-expansion-panel>
                </div>
              </mat-expansion-panel>
            </ng-container>
          </mat-card-content>
        <div style="text-align: center;">
            <button mat-stroked-button (click)="backToHome()">Back to Home</button>
            <button style="margin-left: 10px" mat-flat-button (click)="bookAnotherComplaint()">Book Another Complaint</button>
        </div>
        </mat-card>
      </div>      
</div>